import { type ReactNode } from 'react';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { cs } from '@bbkAdminUtils/css-utils';

export interface SwitchBoxOption {
  id: string;
  value: string;
  label: ReactNode;
}

export interface SwitchBoxProps {
  id: string;
  data: SwitchBoxOption[];
  selectedValue?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

export const SwitchBox = ({
  id,
  data,
  selectedValue,
  onValueChange,
  disabled = false,
}: SwitchBoxProps) => {
  if (!data || data.length === 0) return null;

  return (
    <div>
      <ToggleGroup.Root
        id={id}
        type="single"
        className={cs(
          'tw-relative tw-flex tw-self-center tw-rounded-pricingtable-border-radius tw-transition-all @sm:tw-bg-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_10%,transparent)]',
          'tw-p-2 @sm:tw-p-1',
          'hover:tw-bg-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_15%,transparent)]',
          'tw-flex-wrap tw-justify-center tw-gap-1.5 @sm:tw-gap-0.5'
        )}
        disabled={disabled}
      >
        {data.map((option) => {
          const isActive = option.value === selectedValue;

          return (
            <ToggleGroup.Item
              id={`${id}-${option.id}`}
              className={cs(
                'tw-shadow-base tw-relative tw-whitespace-nowrap tw-rounded-[calc(var(--pricingtable-border-radius)*0.8)] tw-font-medium',
                'tw-px-6 tw-py-4 tw-text-base',
                '@sm:tw-px-4 @sm:tw-py-2 @sm:tw-text-sm',
                'tw-transition-all tw-duration-200 focus-visible:tw-outline-none',
                'tw-flex-1',
                isActive
                  ? 'tw-bg-[var(--pricingtable-style-accent-color)] tw-text-[var(--pricing-page-button-text-color)] tw-shadow'
                  : 'tw-bg-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_10%,transparent)] tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_80%,transparent)] hover:tw-text-[var(--pricing-page-text-font-text-color)] @sm:tw-bg-transparent'
              )}
              key={option.id}
              value={option.value}
              onClick={() => onValueChange(option.value)}
            >
              {option.label}
            </ToggleGroup.Item>
          );
        })}
      </ToggleGroup.Root>
    </div>
  );
};
